"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _iconBase = _interopRequireDefault(require("@kbbcomponentlibrary/icon-base"));

/*eslint import/namespace: ['error', { allowComputed: true }]*/
var IconChevronRight = function IconChevronRight(props) {
  return _react["default"].createElement(_iconBase["default"], props, _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M14.5940421,7.37303314 C13.8357368,6.56988502 13.8720891,5.30407695 14.6752372,4.54577168 C15.4783854,3.78746642 16.7441934,3.82381874 17.5024987,4.62696686 L34.4542283,22.5811476 C35.1813294,23.3512463 35.1820044,24.5546678 34.4557677,25.3255816 L17.4557677,43.3714008 C16.698364,44.1753992 15.4325975,44.2131715 14.6285992,43.4557677 C13.8246008,42.698364 13.7868285,41.4325975 14.5442323,40.6285992 L30.2508563,23.9557229 L14.5940421,7.37303314 Z"
  })));
};
IconChevronRight.displayName = 'IconChevronRight';
var _default = IconChevronRight;
exports["default"] = _default;
IconChevronRight.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "IconChevronRight",
  "props": {
    "size": {
      "required": true,
      "flowType": {
        "name": "number"
      },
      "description": ""
    },
    "viewBox": {
      "required": true,
      "flowType": {
        "name": "string"
      },
      "description": ""
    },
    "colorFill": {
      "required": true,
      "flowType": {
        "name": "string"
      },
      "description": ""
    },
    "children": {
      "required": false,
      "flowType": {
        "name": "ReactElement",
        "raw": "React.Element<*>",
        "elements": [{
          "name": "unknown"
        }]
      },
      "description": ""
    }
  }
};
if (typeof STORYBOOK_REACT_CLASSES !== "undefined") {
  STORYBOOK_REACT_CLASSES["src/ChevronRight.js"] = {
    name: "IconChevronRight",
    docgenInfo: IconChevronRight.__docgenInfo,
    path: "src/ChevronRight.js"
  };
}